/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Csat_LowInputs */

const en_us2_engagement_csat_low = /** @type {(inputs: Engagement_Csat_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poor`)
};

const pt_br2_engagement_csat_low = /** @type {(inputs: Engagement_Csat_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruim`)
};

const es_419_engagement_csat_low = /** @type {(inputs: Engagement_Csat_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mala`)
};

const pt_pt2_engagement_csat_low = /** @type {(inputs: Engagement_Csat_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mau`)
};

const fr_fr2_engagement_csat_low = /** @type {(inputs: Engagement_Csat_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mauvais`)
};

const de_de2_engagement_csat_low = /** @type {(inputs: Engagement_Csat_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlecht`)
};

const it_it2_engagement_csat_low = /** @type {(inputs: Engagement_Csat_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Male`)
};

/**
* | output |
* | --- |
* | "Poor" |
*
* @param {Engagement_Csat_LowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_csat_low = /** @type {((inputs?: Engagement_Csat_LowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Csat_LowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_csat_low(inputs)
	if (locale === "es-419") return es_419_engagement_csat_low(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_csat_low(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_csat_low(inputs)
	if (locale === "de-DE") return de_de2_engagement_csat_low(inputs)
	if (locale === "it-IT") return it_it2_engagement_csat_low(inputs)
	return en_us2_engagement_csat_low(inputs)
});
export { engagement_csat_low as "engagement.csat_low" }